// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../../shared/action-creator/alert-messages';
import { formatGivenDate, setAgGridLicense } from '../../../shared/services/common-functions';
import { getFamiliesFactory, getFamilyWeeks } from '../../../common/repositories';
import BundleAllocationCapacityForecastTable from './components/bundle-allocation-to-capacity-forecast-table';
import BusyCounterLoadingIndicator from '../../../shared/components/busyCounter/busy-counter-loading-indicator';
import LabeledInput from '../../../shared/components/labeled-input';
import OptionsDropDown from '../../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getBundleAllocationCapacityForecast from './repositories';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';

class BundleAllocationCapacityForecast extends Component {

    state = {
        families: [],
        selectedFamily: '',
        weeks: [],
        selectedWeek: -1,
        results: null,
        weeksWithLongFormat: [],
        red: '',
        blue: '',
        submitRed: '',
        submitBlue: ''
    };

    constructor ( props ) {

        super( props );
        this.child = React.createRef();
        setAgGridLicense();

    }

    componentDidMount = () => {

        this.props.increaseCounter();
        getFamiliesFactory( 'Y', 'Y' ).then( response => {

            this.setState( {
                families: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        this.props.increaseCounter();
        getFamilyWeeks( ).then( response => {

            const weeks = response.map( item => {

                let wLab = formatGivenDate( item.weekEnding, 'YYYY-MM-DD' );
                if ( wLab === '2000-01-01' ) wLab = 'Inventory';
                if ( wLab === '2000-02-01' ) wLab = 'Rework';
                return ( { id: item.weekNumber, value: wLab } );

            } );
            this.setState( {
                weeks,
                weeksWithLongFormat: response
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );
        this.setState( {
            red: this.state.red === '' ? '89' : this.state.red,
            blue: this.state.blue === '' ? '26' : this.state.blue
        } );

    }

    handleFamilyDropDownChange ( val ) {

        this.setState( {
            selectedFamily: val,
            results: null
        } );

    }

    handleTextChange ( name, val ) {

        this.setState( {
            [`${name}`]: val.target.value
        }, () => {

            this.refresh();

        } );

    }

    handleColorChange () {

        const {
            submitBlue, submitRed, red, blue
        } = this.state;
        if ( submitRed !== red || submitBlue !== blue ) {

            this.refresh();

        }

    }

    handleWeekDropdownChange ( val ) {

        this.setState( {
            selectedWeek: val
        }, () => {

            this.refresh();

        } );

    }

    exportToExcel = () => {

        this.child.current.exportExcel();

    }

    refresh () {

        if ( this.state.selectedFamily !== '-1' && this.state.selectedWeek !== '-1' ) {

            this.setState( {
                submitRed: this.state.red,
                submitBlue: this.state.blue
            } );
            this.props.increaseCounter();
            getBundleAllocationCapacityForecast(
                this.state.selectedFamily,
                this.state.selectedWeek
            ).then( response => {

                this.setState( {
                    results: response
                } );
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }

    }

    render () {

        const { bundleCapacity } = this.props;
        const {
            families, selectedFamily, selectedWeek, weeks, results, weeksWithLongFormat, red, blue
        } = this.state;

        const pageHeading = bundleCapacity === true ? 'Bundle Capacity Allocation' : 'Bundle Forecast Allocation';

        const arrayResults = results !== null ? [...results] : [];
        const bundleCapFcstResults = arrayResults.map( i => (
            { ...i, unitName: this.props.unit.name } ) );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">{pageHeading}</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-bundle-capacity-forecast-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="families"
                                    label="Family"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleFamilyDropDownChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={families}
                                    placeholder="Select Family"
                                    selectedValue={selectedFamily}
                                    isRequired={false}
                                />
                                <OptionsDropDown
                                    className="weeks"
                                    label="Last Week"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleWeekDropdownChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={weeks}
                                    placeholder="Select Week"
                                    selectedValue={selectedWeek}
                                    isRequired={false}
                                />
                                {selectedFamily && selectedWeek !== -1 && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}
                            </div>
                            <div className="export-button">
                                {selectedFamily && selectedWeek !== -1 &&
                                results !== null && results.length > 0 && (
                                    <button className="primary-button" type="button" onClick={this.exportToExcel.bind( this )}>
                                        <span> Export to Excel </span>
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="label-options">
                            <LabeledInput
                                className="bundle-allocation-red-capfcst-input"
                                name="red"
                                isEditable={true}
                                label="red: % > "
                                onChange={this.handleTextChange.bind( this, 'red' )}
                                onBlur={this.handleColorChange.bind( this )}
                                value={red}
                            />
                            <LabeledInput
                                className="bundle-allocation-blue-capfcst-input"
                                name="blue"
                                isEditable={true}
                                label="blue: % < "
                                onChange={this.handleTextChange.bind( this, 'blue' )}
                                onBlur={this.handleColorChange.bind( this )}
                                value={blue}
                            />
                        </div>
                        { results !== null && (
                            <div>
                                *Only bundles that have at least one week
                                over {red}% allocation are displayed.
                            </div>
                        )
                        }
                        { results !== null && (
                            <BundleAllocationCapacityForecastTable
                                results={bundleCapFcstResults}
                                weeks={weeksWithLongFormat}
                                selectedWeek={selectedWeek}
                                bundleCapacity={bundleCapacity}
                                red={red}
                                blue={blue}
                                ref={this.child}
                            />
                        )}

                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

BundleAllocationCapacityForecast.displayName = 'BundleAllocationCapacityForecast';
BundleAllocationCapacityForecast.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    bundleCapacity: PropTypes.bool
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( BundleAllocationCapacityForecast );
